
import React from 'react'
import { Link, useParams } from 'react-router-dom';
import GetRequest from '../Services/APIRequest'
import Loading from '../Components/Loading'
import Error from '../Components/Error'
import LiveSugImg from '../Assets/img/whitegold1.png';
import newOrderImg from '../Assets/img/Icon/newordericon.png';
import newpaymentImg from '../Assets/img/Icon/newpaymenticon.jpg';
import WhatsAppShareButton from '../Components/WhatsAppShareButton';



const RecommendationDetails = () => {

  const { Id } = useParams();
  const distID = localStorage.getItem('distributorId');
  const boostID = localStorage.getItem('companyIdBooster');
  const parisID = localStorage.getItem('companyIdParis');

  const { data, error, isLoaded } = GetRequest(`/Recommendation/GetRecommandationDetails/${Id}`);

  if (error !== null) {
    return <Error data=" " />;
  }
  if (!isLoaded) {
    return <Loading />;
  }


  return (
    <>
      <section className="content">
        <div className="container-fluid">

          <div className="row">
            <div className="col-md-12">

              <div className="card card-primary">


                <div className="card-body no-padding collapse show" id="collapse-no-head" data-bs-parent="#accordion-no">
                  <ul className="nav flex-column">
                    <div id="accordion farmerLiveHomeUI">
                      {data.result && data.result.map(item => (
                        <div className="card mb-4 border-0 shadow" key={item.id}>
                          <div
                            className="card-header d-flex justify-content-between align-items-center text-white"
                            data-bs-toggle="collapse"
                            href={`#collapse${item.id}`}
                            style={{ backgroundColor: '#17a2b8', cursor: 'pointer' }}
                          >
                            <div>
                              <h5 className="mb-0">{item.title}</h5>
                              <small>
                                <span className="badge bg-warning text-dark me-2">
                                  Language: {item.languageName}
                                </span>
                                <span className="badge bg-light text-dark">
                                  Recommended On: {new Date(item.recommendedOn).toLocaleDateString()}
                                </span>
                              </small>
                            </div>
                            <i className="fa fa-chevron-down text-white"></i>
                          </div>

                          <div id={`collapse${item.id}`} className="collapse" data-bs-parent="#accordion">
                            <div className="card-body" style={{ backgroundColor: '#f9f9f9' }}>

                              {item.isSimpleText ? (
                                <div className="d-flex justify-content-between align-items-center">
                                  <p className="mb-0 fs-5 fw-semibold text-primary">
                                    {item.title}
                                  </p>
                                  {/* <a
                                    href={`whatsapp://send?text=${item.messageForSharing}`}
                                    data-action="share/whatsapp/share"
                                    className="text-success"
                                    target="_blank"
                                    rel="noreferrer"
                                    title="Share on WhatsApp"
                                  >
                                    <i className="fa fa-whatsapp fa-lg"></i>
                                  </a> */}
                                  <WhatsAppShareButton message={item.messageForSharing} />

                                </div>
                              ) : (
                                <>
                                  <p className="text-dark">
                                    <strong className="text-info">Problem:</strong> {item.fieldProblemTitle}
                                    {/* <a
                                      href={`whatsapp://send?text=${item.messageForSharing}`}
                                      data-action="share/whatsapp/share"
                                      className="ms-3 text-success"
                                      target="_blank"
                                      rel="noreferrer"
                                      title="Share on WhatsApp"
                                    >
                                      <i className="fa fa-whatsapp fa-lg"></i>
                                    </a> */}
                                    <WhatsAppShareButton message={item.messageForSharing} />

                                    <br />
                                    <strong className="text-info">Problem Type:</strong> {item.problemGroupTitle}<br />
                                    <strong className="text-info">Suggestions:</strong> {item.suggestion}
                                  </p>

                                  {item.recommendedProductLines && item.recommendedProductLines.length > 0 && (
                                    <>
                                      <h6 className="text-success mt-3">🌿 Recommended Products</h6>
                                      {item.recommendedProductLines.map((prod, index) => (
                                        <div className="border rounded p-3 mb-3" key={index} style={{ backgroundColor: '#fffaf0' }}>
                                          <p className="mb-1">
                                            <strong className="text-primary">Product:</strong> {prod.productName}
                                          </p>
                                          <p className="mb-1">
                                            <strong className="text-primary">Per Pump:</strong> {prod.dosageInformationPerPump}
                                          </p>
                                          <p className="mb-1">
                                            <strong className="text-primary">Per Acre:</strong> {prod.dosageInformationPerAcre}
                                          </p>
                                          <p className="mb-0">
                                            <strong className="text-primary">Comments:</strong> {prod.comments}
                                          </p>
                                        </div>
                                      ))}
                                    </>
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}

                    </div>
                  </ul>
                </div>

              </div>




            </div>
          </div>


        </div>
      </section>
    </>
  )
}

export default RecommendationDetails